import React, { useEffect, useState } from "react";
import style from "react-syntax-highlighter/dist/esm/styles/hljs/a11y-dark";

const RequestSequence = ({ sequence, selectRequest, currentTransaction }) => {
    //Based on the changes on current transaction
    useEffect(() => {
        if (currentTransaction != null && sequence != null) {
            selectRequest(sequence.find((seq) => seq.identifier == currentTransaction.identifier))
        }
    }, [currentTransaction, sequence])

    return (
        <div className="list-group">
            {sequence && sequence.map((item, index) => {
                let outPut = ""
                const style = {
                    color: 'green'
                };
                if (item.responseCode == 201 || item.responseCode == 200) {
                    outPut = item.onlineAPIRefId;
                } else {
                    outPut = item.responseBody?.errorCode
                    style.color = 'red'
                }
                var active = "list-group-item list-group-item-action flex-column align-items-start";
                if (currentTransaction?.identifier == item.identifier) {
                    active = "list-group-item list-group-item-action flex-column align-items-start current-txn"
                }

                var classMethodBadge = "badge text-bg-success"
                switch (item.method) {
                    case "GET":
                        classMethodBadge = "badge text-bg-primary"
                        break;
                    case "PUT":
                        classMethodBadge = "badge text-bg-warning"
                        break;
                    case "DELETE":
                        classMethodBadge = "badge text-bg-danger"
                        break;
                    default:
                        break;
                }
                return (
                    <a href="#" className={active} onClick={(e) => selectRequest(item)}>
                        <div className="sequence-content d-flex w-100 justify-content-between">
                            <div>
                                <p className="mb-1"><span style={{marginRight: "8px", minWidth:"40px" }} className={classMethodBadge}>{item.method}</span>{item.url}</p>
                            </div>
                            <div className="request-output">
                                <small style={style}>{item.responseCode}</small>
                                <small >{outPut}</small>
                            </div>
                        </div>
                        <small className="text-muted"></small>
                    </a>)
            }
            )}
        </div>
    );
};

export default RequestSequence;